import { Mediator, app } from "modular-openscriptjs";
import { eParse } from "../helpers";

const $e = app("$e");

export class MentionMediator extends Mediator {
	$$mention = {
		needs: {
			search: (ed, event) => this.send($e.mention.needs.searchForm, ed),
		},
		clicked: (ed, event) => this.handleClick(ed, event),
	};

	async handleClick(ed, event) {
		let { content } = eParse(ed).message;

		if (/^\s*?@/.test(content)) {
			location.href = `/${content.trim()}`;
		}
	}
}
